import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

import { ImageDialogComponent } from '../partials/image-dialog/image-dialog.component';
import { BannerDialogComponent } from '../partials/banner-dialog/banner-dialog.component';

@Component({
  selector: 'app-fachgebiete-nephrologie',
  templateUrl: './fachgebiete-nephrologie.component.html',
  styleUrls: ['../fachgebiete/fachgebiete.component.scss']
})
export class FachgebieteNephrologieComponent implements OnInit {

  constructor(
    private _router: Router,
    public _matDialog: MatDialog
    ) { }

  ngOnInit(): void {

    window.scrollTo(0, 0);

    setTimeout(()=>{
      var url = window.location.hash.substr(1);
      var yOffset = -250;
      const element = document.getElementById(url);
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({top: y, behavior: 'smooth'});
    }, 200);

    const supTags = document.querySelectorAll('sup');

    for (var i = 0; i < supTags.length; i++) {
      supTags[i].addEventListener('click', this.goToReferences.bind(this));
      supTags[i].setAttribute('style', 'cursor: pointer;');
    }

  }

  goToReferences(event): void {
    this.navigateTo('/referenzen');
  }

  navigateTo(url){
    this._router.navigate([url], { fragment: 'fachgebiete|Nephrologie' });
    // document.body.scrollTop = 0;
  }

  openDialog(id) {
    this._matDialog.open(ImageDialogComponent, {
      data: {
        identifier: id
      },
      panelClass: 'image-dialog-container'
    });

  }

}
